import { useCallback, useEffect, useRef } from 'react';

export const useSetTimeoutAutoClear = () => {
	const timeoutRef = useRef<NodeJS.Timeout | undefined>();

	useEffect(
		() => () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		},
		[],
	);

	const setTimeoutAutoClear = useCallback((...args: Parameters<typeof setTimeout>): void => {
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}
		timeoutRef.current = setTimeout(...args);
	}, []);

	return { setTimeoutAutoClear };
};
